import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class UserSignature extends _BaseUserProfile {
  component = 'SignatureForm';
  props = {
    title: null,
    errorMessage: 'Signature is Required',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
  };
  hideClearUntilValue = true;
}
